import { useTranslation } from 'react-i18next';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import { DependencyIndicator } from '@/features/item-panel/components/tabs/dependencies/DependencyIndicator';
import type { ItemsTableRow } from '@/features/items/components/table/types';

export const DependencyPredecessorCell = ({
  row,
  currentItemHealth,
}: {
  row: ItemsTableRow;
  currentItemHealth: ItemHealth | undefined;
}) => {
  const { t } = useTranslation();
  const isBlocked =
    currentItemHealth?.dependency?.blockedByPredecessorIds.includes(row.id) ?? false;
  const isAtRisk =
    !isBlocked && (currentItemHealth?.dependency?.atRiskPredecessorIds.includes(row.id) ?? false);

  return (
    <DependencyIndicator
      isError={isBlocked}
      isWarning={isAtRisk}
      tooltip={
        isBlocked
          ? t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.blockedTooltip)
          : t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.atRiskTooltip)
      }
      alertDotTestId="predecessor-alert-dot"
    />
  );
};
